export default __webpack_public_path__ + "static/media/down-arrow.b56e16a7.svg";